import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AkkhorLayout from "../layout/akkhor";
import Axios from "axios";
import { useFormik } from "formik";
import Spinner from "../component/Spinner";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";
import AlertErrorForm from "../component/AlertErrorForm";
import * as Yup from "yup";

export default function ChotCongThang(props) {
    const { user } = useSelector((state) => state.auth);
    const [month, setMonth] = useState([])
    const [year, setYear] = useState([])
    // Danh sách công ty + ngày chốt riêng, để chốt công theo TỪNG công ty.
    // Mỗi công ty có thể có kỳ công khác nhau (company.chotcong) nên không thể
    // chốt chung một lượt: kỳ của công ty này đã hết, công ty kia còn đang chạy.
    const [dsCongTy, setDsCongTy] = useState([])

    useEffect(() => {
        let mounted = true;
        Axios.get(URL_LIST_ALL + "chotcong_congty", user.config)
            .then((res) => {
                if (mounted && res.data.status === "success") setDsCongTy(res.data.data || [])
            })
            .catch((err) => console.log(err));
        return () => (mounted = false);
    }, [user]);
    
    // Ranh giới kỳ công: kỳ "tháng M" chạy từ ngày chốt của tháng M-1 đến hôm trước
    // ngày chốt của tháng M. Giống App\Services\KyCong::khoang() bên backend.
    const tinhKy = (thang, nam, ngayChot) => {
        const m = parseInt(thang, 10), y = parseInt(nam, 10), d = parseInt(ngayChot, 10) || 26;
        const batDau = new Date(y, m - 2, d);
        const ketThuc = new Date(y, m - 1, d - 1);
        const fmt = (x) => `${String(x.getDate()).padStart(2, '0')}/${String(x.getMonth() + 1).padStart(2, '0')}/${x.getFullYear()}`;
        return { batDau, ketThuc, nhan: `${fmt(batDau)} → ${fmt(ketThuc)}`, daKetThuc: new Date() > ketThuc };
    };

    const formik = useFormik({
        // BUG cũ: thiếu dấu () -> month/year là THAM CHIẾU HÀM, không phải số.
        // Bấm khi chưa tự chọn lại -> gửi chuỗi rác -> strtotime() ra "tháng 1/1970"
        // (đã từng tạo chotcong_settings id=18 + 1.644 bản baocaochamcong năm 1970).
        // getMonth() đếm từ 0 nên phải +1; pad '0' cho khớp value của <option>.
        initialValues: {
            month: String(new Date().getMonth() + 1).padStart(2, '0'),
            year: new Date().getFullYear(),
            company_id: '',
        },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            month: Yup.string().trim().nullable().required('Vui lòng chọn tháng'),
            year: Yup.string().trim().nullable().required('Vui lòng chọn năm')
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            let _url = URL_LIST_ALL + 'chotcong?export=true'
            if (values && values.month && values.year) _url = _url + '&time=' + values.year + '-'+values.month
            if (values && values.company_id) _url = _url + '&company_id=' + values.company_id

            // Xác nhận TRƯỚC khi chốt: nêu rõ chốt cho ai, khoảng ngày nào, và cảnh
            // báo nếu kỳ chưa kết thúc (sự cố 23/09/2026: chốt nhầm khi kỳ đang chạy
            // -> khóa toàn bộ đăng ký + giải trình của cả kỳ).
            const cty = values.company_id ? dsCongTy.find((c) => String(c.id) === String(values.company_id)) : null;
            const dsChot = cty ? [cty] : dsCongTy;
            const dong = dsChot.map((c) => {
                const k = tinhKy(values.month, values.year, c.ngay_ap_dung);
                return `• ${c.title}: ${k.nhan}${k.daKetThuc ? '' : '  ⚠ KỲ CHƯA KẾT THÚC'}`;
            });
            const coChuaXong = dsChot.some((c) => !tinhKy(values.month, values.year, c.ngay_ap_dung).daKetThuc);

            confirmAlert({
                title: 'Xác nhận chốt công',
                message: `Chốt công kỳ tháng ${values.month}/${values.year} cho ${cty ? cty.title : `TẤT CẢ ${dsChot.length} công ty`}.`
                    + (coChuaXong ? '\n\n⚠ Có công ty kỳ công CHƯA KẾT THÚC — chốt lúc này sẽ khóa đăng ký nghỉ và giải trình của những ngày còn lại.' : ''),
                childrenElement: () => (
                    <div style={{ maxHeight: 260, overflowY: 'auto', marginTop: 10, fontSize: 13 }}>
                        {dong.map((d, i) => (
                            <div key={i} style={{ color: d.includes('⚠') ? '#c0392b' : undefined }}>{d}</div>
                        ))}
                    </div>
                ),
                buttons: [
                    { label: 'Chốt công', onClick: () => chayChot(_url, resetForm, setSubmitting) },
                    { label: 'Huỷ', onClick: () => setSubmitting(false) },
                ],
            });
        },
    });

    // Gọi API chốt công sau khi QTNS đã xác nhận.
    const chayChot = (_url, resetForm, setSubmitting) => {
            Axios.get(_url, user.config).then(async (res) => {
                setSubmitting(false);
                if (res.data.status === "success") {
                    resetForm();
                    confirmAlert({
                        title: 'Thông báo',
                        message: "Đang tạo báo cáo, vui lòng đợi email thông báo sau khi thành công",
                        buttons: [{ label: 'OK' }]
                    });
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch((err) => { setSubmitting(false); console.log(err); });
    };

    // Hủy chốt công tháng: gỡ bản ghi chốt + mở lại các bản bị khóa bởi lần chốt đó.
    // Thêm sau sự cố 23/09/2026 (QTNS bấm nhầm nút chốt khi kỳ chưa kết thúc).
    const [dangHuy, setDangHuy] = useState(false);
    const huyChotCong = () => {
        const { month, year } = formik.values;
        if (!month || !year) {
            confirmAlert({ title: 'Thông báo', message: 'Vui lòng chọn tháng và năm cần hủy chốt', buttons: [{ label: 'OK' }] });
            return;
        }
        confirmAlert({
            title: 'Xác nhận hủy chốt công',
            message: `Hủy chốt công kỳ tháng ${month}/${year} cho ${formik.values.company_id
                ? (dsCongTy.find((c) => String(c.id) === String(formik.values.company_id)) || {}).title
                : 'TẤT CẢ công ty'}? Nhân sự sẽ đăng ký nghỉ trở lại được, và các giải trình/đăng ký bị khóa bởi lần chốt đó sẽ mở lại.`,
            buttons: [
                {
                    label: 'Hủy chốt',
                    onClick: () => {
                        setDangHuy(true);
                        const cid = formik.values.company_id ? `&company_id=${formik.values.company_id}` : '';
                        Axios.get(`${URL_LIST_ALL}huychotcong?time=${year}-${month}${cid}`, user.config).then(res => {
                            setDangHuy(false);
                            confirmAlert({
                                title: res.data.status === 'success' ? 'Thành công' : 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }).catch(err => {
                            setDangHuy(false);
                            confirmAlert({ title: 'Lỗi', message: err.message, buttons: [{ label: 'OK' }] });
                        });
                    }
                },
                { label: 'Không' }
            ]
        });
    };

    useEffect(function () {
        let _month = []
        for (let m = 1; m <= 12; m++) {
            _month.push(m)
        }
        setMonth(_month)

        let _year = []
        let maxYear = new Date().getFullYear()
        for (let y = 2021; y <= maxYear; y++) {
            _year.push(y)
        }
        setYear(_year)
    }, []);

    return (
        <AkkhorLayout idrole="list-users" >
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/list-users_onday">Danh sách chấm công</Link>
                    </li>
                    <li>Tạo báo cáo chấm công</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Tạo báo cáo Chấm công</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 mg-t-8">
                                <div className="col-12 col-sm-4 form-group">
                                    <div className="row">
                                        <div className="col-lg-6 col-12 form-group">
                                            <label>Chọn tháng</label>
                                            <select className="form-select height32" {...formik.getFieldProps("month")}>
                                                {month && month.map((item, i) => {
                                                    return <option key={i} value={item < 10 ? '0'+ item.toString() : item}>Tháng {item}</option>
                                                })}
                                            </select>
                                            <AlertErrorForm formik={formik} name="month"></AlertErrorForm>
                                        </div>
                                        <div className="col-lg-6 col-12 form-group">
                                            <label>Chọn năm</label>
                                            <select className="form-select height32" {...formik.getFieldProps("year")}>
                                                {year && year.map((item, i) => {
                                                    return <option key={i} value={item < 10 ? '0'+ item.toString() : item}>{item}</option>
                                                })}
                                            </select>
                                            <AlertErrorForm formik={formik} name="year"></AlertErrorForm>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 form-group">
                                    <label>Chọn công ty</label>
                                    <select className="form-select height32" {...formik.getFieldProps("company_id")}>
                                        <option value="">— Tất cả công ty —</option>
                                        {dsCongTy.map((c) => (
                                            <option key={c.id} value={c.id}>
                                                {c.title}{c.dung_chung ? '' : ` (chốt ngày ${c.ngay_ap_dung})`}
                                            </option>
                                        ))}
                                    </select>
                                    {(() => {
                                        const cty = formik.values.company_id
                                            ? dsCongTy.find((c) => String(c.id) === String(formik.values.company_id))
                                            : null;
                                        if (!cty || !formik.values.month || !formik.values.year) return null;
                                        const k = tinhKy(formik.values.month, formik.values.year, cty.ngay_ap_dung);
                                        return (
                                            <div className="mt-1" style={{ fontSize: 13 }}>
                                                Kỳ công: <strong>{k.nhan}</strong>{' '}
                                                {k.daKetThuc
                                                    ? <span className="text-success">✓ đã kết thúc</span>
                                                    : <span className="text-danger">⚠ chưa kết thúc</span>}
                                            </div>
                                        );
                                    })()}
                                </div>
                                <div className="col-12"></div>

                                <div className="alert alert-primary" role="alert">
                                    <div className="mt-3">
                                        <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark mr-2">{formik.isSubmitting ? <Spinner /> : <>Bắt đầu tạo</>}</button>
                                        <button type="button" onClick={huyChotCong} disabled={dangHuy} className="btn btn-danger">{dangHuy ? <Spinner /> : <><i className="fas fa-undo"></i> Hủy chốt công tháng</>}</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
